
import { X } from "lucide-react";

interface MediaPreviewProps {
  mediaPreview: string | null;
  mediaFiles: File[];
  clearMedia: () => void;
}

export const MediaPreview = ({ mediaPreview, mediaFiles, clearMedia }: MediaPreviewProps) => {
  if (!mediaPreview) return null;

  return (
    <div className="relative">
      {mediaFiles[0]?.type.startsWith('image/') ? (
        <img 
          src={mediaPreview} 
          alt="Preview" 
          className="w-full max-h-40 sm:max-h-56 rounded-lg object-cover"
        />
      ) : (
        <video 
          src={mediaPreview} 
          className="w-full max-h-40 sm:max-h-56 rounded-lg object-contain"
          controls
        />
      )}
      <button
        onClick={clearMedia}
        className="absolute top-2 right-2 p-1.5 bg-black/50 rounded-full hover:bg-black/70 transition-colors"
      >
        <X className="w-3 h-3 text-white" />
      </button>
    </div>
  );
};
